import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepTwoLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepTwoLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.climbStepTwoLevels.data.climbStepTwoLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
